import React from 'react'
import { Spin } from 'antd'
import styled from 'styled-components'

const WrapOptionCancel = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
`

export default function AppLoader() {
  return (
    <WrapOptionCancel>
      <Spin />
    </WrapOptionCancel>
  )
}
